module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjAwIiBoZWlnaHQ9IjYwMCIgdmlld0JveD0iMCAwIDYgMyI+PHBhdGggZmlsbD0iIzAwN0EzRCIgZD0iTTAgMGg2djNIMHoiLz48cGF0aCBmaWxsPSIjRkZGIiBkPSJNMCAwaDZ2MkgweiIvPjxwYXRoIGQ9Ik0wIDBoNnYxSDB6Ii8+PHBhdGggZmlsbD0iI0NFMTEyNiIgZD0iTTAgMGwyIDEuNUwwIDN6Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/pse.svg
// module id = Fg7E
// module chunks = 0